export default "__VITE_ASSET__DmCw0xz5__";